<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Chamado</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <ticket-page/>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import TicketPage from '_modules/ticket/components/TicketPage.vue';

export default {
  name: 'ticket-create',
  components: {
    TicketPage,
  },
  computed: {
  },
  data() {
    return {};
  },
  created() {
    Events.$emit('sidebarVisible', false);
  },
};
</script>

